
(function () {
  const instances = new WeakMap();
  const observers = new WeakMap();

  const scrollbarSettings = {
    slidesPerView: 2,
    spaceBetween: 16,
    mousewheel: { forceToAxis: true },
    speed: 400,
    allowTouchMove: true,
    breakpoints: {
      990: { slidesPerView: 3 },
      1440: { slidesPerView: 4 },
    },
  };

  const sliderSettings = {
    slidesPerView: 1,
    spaceBetween: 16,
    speed: 800,
    allowTouchMove: true,
  };

  /* BRANDIFYME_MOBILE_ARROW_ALIGNMENT_FIX */
  function positionMobileArrows(section) {
    if (!window.matchMedia('(max-width: 575px)').matches) return;

    const wrapper = section.querySelector('.popular-products__wrapper');
    const activeSlide = section.querySelector(
      '.popular-products__item.swiper-slide-active'
    );

    const media = activeSlide?.querySelector(
      '.card__media, .card__inner, .card-wrapper .media, img'
    );

    if (!wrapper || !media) return;

    const parentRect = wrapper.getBoundingClientRect();
    const mediaRect = media.getBoundingClientRect();

    if (!mediaRect.height) return;

    wrapper.style.setProperty(
      '--popular-mobile-image-center',
      (mediaRect.top - parentRect.top + mediaRect.height / 2) + 'px'
    );
  }

  /* BRANDIFYME_MOBILE_ARROW_INITIAL_RENDER_FIX */
  function scheduleMobileArrowPosition(section) {
    if (!window.matchMedia('(max-width: 575px)').matches) return;

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        positionMobileArrows(section);
      });
    });
  }

  function initSlider(section, settings) {
    const sliderContainer = section.querySelector('.popular-products');
    const swiperEl = section.querySelector('.popular-products__layout');
    const swiperWrapper = section.querySelector('.popular-products__list');
    const slides = section.querySelectorAll('.popular-products__item');

    if (!sliderContainer || !swiperEl || !swiperWrapper || !slides.length) return;

    swiperEl.classList.add('swiper');
    swiperWrapper.classList.add('swiper-wrapper');

    slides.forEach((slide) => slide.classList.add('swiper-slide'));

    const bar = settings === 'bar';

    const controls = bar
      ? section.querySelector('.popular-products__bar-container')
      : section.querySelector('.popular-products__navigation--mobile');

    const nextBtn = controls?.querySelector(
      '.popular-products__navigation-button-next'
    );

    const prevBtn = controls?.querySelector(
      '.popular-products__navigation-button-prev'
    );

    const progressBar = section.querySelector('.swiper-scrollbar');

    const options = bar
      ? {
          ...scrollbarSettings,
          scrollbar: {
            el: progressBar,
            grabCursor: true,
            draggable: true,
            hide: false,
          },
          navigation: nextBtn && prevBtn
            ? { nextEl: nextBtn, prevEl: prevBtn }
            : false,
        }
      : {
          ...sliderSettings,
          slidesPerView: 1,
          loop: false,
          rewind: false,

          autoplay: slides.length > 1
            ? {
                delay: 3000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
              }
            : false,

          navigation: nextBtn && prevBtn
            ? {
                nextEl: nextBtn,
                prevEl: prevBtn,
                disabledClass: 'swiper-button-disabled',
              }
            : false,

          on: {
            init() {
              scheduleMobileArrowPosition(section);
            },

            slideChange() {
              scheduleMobileArrowPosition(section);
            },

            autoplay(swiper) {
              // Keep finite navigation: at the last card, restart autoplay at first.
              if (swiper.isEnd && !swiper.animating) {
                swiper.slideTo(0);
              }
            },
          },
        };

    const swiper = new Swiper(swiperEl, options);
    instances.set(section, swiper);

    /* BRANDIFYME_MOBILE_INITIAL_ARROW_POSITION_FIX */
    if (!bar) {
      const updateMobileArrowPosition = () => {
        scheduleMobileArrowPosition(section);
      };

      section.querySelectorAll('.popular-products__item img').forEach((img) => {
        if (!img.complete) {
          img.addEventListener('load', updateMobileArrowPosition, {
            once: true,
          });
        }
      });

      updateMobileArrowPosition();

      if (document.fonts?.ready) {
        document.fonts.ready.then(updateMobileArrowPosition);
      }

      window.addEventListener('load', updateMobileArrowPosition, {
        once: true,
      });
    }
  }

  function destroySlider(section) {
    const swiper = instances.get(section);
    if (!swiper) return;

    swiper.destroy(true, true);
    instances.delete(section);

    const swiperEl = section.querySelector('.popular-products__layout');
    const swiperWrapper = section.querySelector('.popular-products__list');

    swiperEl?.classList.remove('swiper');
    swiperWrapper?.classList.remove('swiper-wrapper');

    section.querySelectorAll('.popular-products__item').forEach((slide) => {
      slide.classList.remove('swiper-slide');
    });
  }

  function initPopularProducts(section) {
    if (
      !section?.classList.contains('popular-products-section') ||
      observers.has(section)
    ) return;

    const container = section.querySelector('.popular-products');
    if (!container) return;

    const cardsLayout = container.dataset.layout || 'grid';
    const cardsMobileLayout = container.dataset.layoutMobile || 'column';

    let currentLayout = null;

    const observer = new ResizeObserver((entries) => {
      const width = entries[0].contentRect.width;

      const newLayout = width < 576
        ? (cardsMobileLayout === 'slider' ? 'slider' : 'column')
        : (cardsLayout === 'bar' ? 'bar' : 'grid');

      if (newLayout !== currentLayout) {
        currentLayout = newLayout;

        destroySlider(section);

        if (newLayout === 'slider' || newLayout === 'bar') {
          initSlider(section, newLayout);
        }
      } else if (newLayout === 'slider') {
        positionMobileArrows(section);
      }
    });

    observer.observe(section);
    observers.set(section, observer);
  }

  function animateProductCards(section) {
    if (
      !section?.classList.contains('popular-products-section') ||
      !section.querySelector('.animate-on-scroll')
    ) return;

    const layout = section.querySelector('.popular-products__layout');

    if (!layout || typeof ScrollTrigger === 'undefined') return;

    ScrollTrigger.create({
      trigger: layout,
      start: '20% bottom',
      end: 'bottom top',
      onEnter: () => layout.classList.add('animated'),
    });
  }

  const initial = document.currentScript?.closest(
    '.popular-products-section'
  );

  if (initial) {
    initPopularProducts(initial);
    animateProductCards(initial);
  } else {
    document.querySelectorAll('.popular-products-section').forEach((section) => {
      initPopularProducts(section);
      animateProductCards(section);
    });
  }

  document.addEventListener('shopify:section:load', (event) => {
    initPopularProducts(event.target);
    animateProductCards(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const section = event.target;

    observers.get(section)?.disconnect();
    observers.delete(section);

    destroySlider(section);
  });
})();
